import { Loader2 } from 'lucide-react';
import { useT } from '@/i18n';
import { cn } from '@/lib/utils';
import { TintBox, BTN_SEC } from '@/components/brand/brand';

/**
 * PD · «Dejar para después» (Edd, 25-oct-2026). El aviso del 409
 * PARENT_HAS_SUBMITTED_SUBS — el de la pre-llamada (T2-A, «Volver a la cola»)
 * y el del wizard (T2-C, «Salir») —, ahora con su salida explícita: el botón
 * «Dejar para después» y la línea que dice qué pasa con el screening.
 *
 * Solo se monta después del 409 del padre retenido: un padre sin familiares
 * enviados sigue saliendo como siempre y nunca ve esto.
 */
export function AvisoPadreRetenido({
  testId,
  titulo,
  cuerpo,
  onDejar,
  pendiente,
  deshabilitado = false,
}: {
  testId: string;
  titulo: string;
  cuerpo: string;
  onDejar: () => void;
  pendiente: boolean;
  deshabilitado?: boolean;
}): JSX.Element {
  const t = useT();
  return (
    <div data-testid={testId} role="alert" className="mb-4">
      <TintBox tone="amber" className="flex items-start justify-between gap-3 flex-wrap">
        <div className="min-w-0 flex-1">
          <p className="font-head text-[12.5px] font-bold m-0 mb-0.5">{titulo}</p>
          <p className="m-0 text-[13px]">{cuerpo}</p>
          <p className="m-0 mt-1.5 text-[13px]">{t('pd.dejar.explica')}</p>
        </div>
        <button
          type="button"
          className={cn(BTN_SEC, 'text-[13px] shrink-0')}
          onClick={onDejar}
          disabled={pendiente || deshabilitado}
        >
          {pendiente && <Loader2 className="h-3.5 w-3.5 animate-spin" aria-hidden />}
          {t('pd.dejar.boton')}
        </button>
      </TintBox>
    </div>
  );
}
